// Modules
import { Component } from '@angular/core';
import { Store, select } from '@ngrx/store';

// Rxjs
import { take } from 'rxjs/operators';

// Store - Reducer
import { AppState } from '@store/reducers';
// Store - Actions
import * as AuthActions from '@store/actions/auth.actions';
// Store - Selectors
import * as AuthSelectors from '@store/selectors/auth.selectors';

@Component({
    selector: 'sbi-cot-back-logout-confirmation-dialog',
    templateUrl: './logout-confirmation-dialog.component.html',
    standalone: false
})
export class LogoutConfirmationDialogComponent {
  // Public selectors
  public signingOut$ = this._store$.pipe(
    select(AuthSelectors.selectSigningOutStatus)
  );

  // Private selectors
  private _loggedUser$ = this._store$.pipe(
    select(AuthSelectors.selectLoggedUser)
  );

  // Constructor
  constructor(private _store$: Store<AppState>) {}

  // Public method to logout
  public onLogout(): void {
    this._loggedUser$.pipe(take(1)).subscribe(user => {
      this._store$.dispatch(AuthActions.logoutRequested({ payload: user }));
    });
  }
}
